import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { FiCalendar } from "react-icons/fi";
import {
  buildGoogleCalendarUrl,
  downloadSchoolTaskIcs,
  SchoolTaskCalendarItem,
} from "./schoolTaskCalendarExport";

export default function SchoolTaskCalendarAction({ item }: { item: SchoolTaskCalendarItem }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasValidStart = Number.isFinite(new Date(item.startsAt).getTime());

  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [open]);

  if (!hasValidStart) return null;

  return (
    <div className="shrink-0">
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        className="inline-flex min-h-9 items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-bold text-slate-600 shadow-sm transition hover:border-emerald-300 hover:text-emerald-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
      >
        <FiCalendar aria-hidden="true" />
        {t("schoolTasks.addToCalendar", { defaultValue: "Add to calendar" })}
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-slate-950/30 p-3 sm:items-center" onMouseDown={() => setOpen(false)}>
        <div role="dialog" aria-modal="true" aria-label={t("schoolTasks.addToCalendar", { defaultValue: "Add to calendar" })} className="grid w-full max-w-xs overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-2xl dark:border-slate-700 dark:bg-slate-900" onMouseDown={(event) => event.stopPropagation()}>
          <button
            type="button"
            onClick={() => {
              downloadSchoolTaskIcs(item);
              setOpen(false);
            }}
            className="rounded-lg px-3 py-2 text-left text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {t("schoolTasks.calendarAppleOutlook", { defaultValue: "Apple / Outlook (.ics)" })}
          </button>
          <a
            href={buildGoogleCalendarUrl(item)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="rounded-lg px-3 py-2 text-left text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {t("schoolTasks.calendarGoogle", { defaultValue: "Google Calendar" })}
          </a>
          <button type="button" onClick={() => setOpen(false)} className="mt-1 rounded-lg px-3 py-2 text-sm font-bold text-slate-500 transition hover:bg-slate-50 dark:text-slate-400 dark:hover:bg-slate-800">
            {t("common.cancel", { defaultValue: "Cancel" })}
          </button>
        </div>
        </div>,
        document.body,
      )}
    </div>
  );
}
